'use client'

import dynamic from 'next/dynamic'
import type { Media } from '@/payload-types'

const ClientTeam1Block = dynamic(() => import('@/components/ui/ClientTeam1Block'))

type SocialLink = {
  platform: 'linkedin' | 'twitter' | 'github' | 'email' | 'website'
  url: string
  id?: string
}

type TeamMember = {
  name: string
  role: string
  avatar: string | Media
  bio?: string
  socialLinks?: SocialLink[]
  id?: string
}

type Props = {
  heading?: string
  description?: string
  members: TeamMember[]
}

const ClientWrapper = ({ heading, description, members }: Props) => {
  return <ClientTeam1Block heading={heading} description={description} members={members} />
}

export default ClientWrapper
